module.exports = __webpack_public_path__ + "img/lowb.f3a8ee34.png";